import { useEffect } from 'react';
import { vars } from '@etg/wings';
import { LoadingDots } from '@eti/components';
import { css, cx } from '@eti/styles';

const getContainerStyles = css`
  align-items: center;
  color: ${vars.colors.links.default};
  display: flex;
  font-size: 2.5rem;
  height: 100%;
  justify-content: center;
`;
const pageClass = css`
  .etiMainContent {
    align-items: center;
    display: flex;
    justify-content: center;
  }
`;

interface LoadingProps {
  className?: string;
  dataTestId?: string;
}

const Loading = ({ dataTestId, className }: LoadingProps) => {
  useEffect(() => {
    document.body.classList.add(pageClass);
    return () => {
      document.body.classList.remove(pageClass);
    };
  }, []);

  return <LoadingDots containerStyle={cx(getContainerStyles, className)} dataTestId={dataTestId} />;
};

export default Loading;
